import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';

import axios from '../../utilities/axios';
import { queryifyObject } from '../../utilities/queryifyObject';
import { freebiesApi } from '../../utilities/apiEndpointUtility';

import {
	getFreebieById,
	getFreebieByIdCompleted,
	getFreebieByIdFailed,
	submitEasyTranscribe,
	submitEasyTranscribeCompleted,
	submitEasyTranscribeFailed
} from './freebiesSlice';

export const getFreebieByIdEpic = (action$) =>
	action$.pipe(
		ofType(getFreebieById.type),
		mergeMap(async (action) => {
			const payload = action.payload;
			const setQueryParams = queryifyObject(payload.telemetry);

			const response = await axios.get(
				`${freebiesApi()}/api/v1/freebies/${payload.id}${setQueryParams}`
			);

			if (response.status !== 200) {
				throw response.data;
			}

			return response.data;
		}),
		switchMap((res) => [getFreebieByIdCompleted(res)]),
		catchError((error, source) =>
			merge(of(getFreebieByIdFailed(error.message)), source)
		)
	);

export const submitEasyTranscribeEpic = (action$) =>
	action$.pipe(
		ofType(submitEasyTranscribe.type),
		mergeMap(async (action) => {
			const payload = action.payload;
			const formData = new FormData();

			if (payload.file) {
				formData.append('file', payload.file);
			}

			delete action.payload.file;

			for (const [key, value] of Object.entries(action.payload)) {
				formData.append(key, value);
			}

			const response = await axios.post(
				`${freebiesApi()}/api/v1/freebies/easy-transcribe`,
				formData,
				{
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
			);

			if (response.status !== 200) {
				throw response.data;
			}

			return response.data;
		}),
		switchMap((res) => [submitEasyTranscribeCompleted(res)]),
		catchError((error, source) =>
			merge(of(submitEasyTranscribeFailed(error.message)), source)
		)
	);

export default [getFreebieByIdEpic, submitEasyTranscribeEpic];
